export const GOLFERS = [
    {
        name: "Brooks Koepka",
        position: 2,
        posQualifier: "T",
        curScore: "-8",
        rounds: [ 65,67,73,75 ],
        winnings: 1594000,
    },
    {
        name: "Cameron Smith",
        position: 34,
        posQualifier: "T",
        curScore: "+4",
        rounds: [ 70,72,75,75],
        winnings: 92880,
    },
    {
        name: "Cameron Young",
        position: 7,
        posQualifier: "T",
        curScore: "-6",
        rounds: [ 67,72,75,68 ],
        winnings: 580500,
    },
    {
        name: "Collin Morikawa",
        position: 10,
        posQualifier: "T",
        curScore: "-4",
        rounds: [ 69,69,74,72 ],
        winnings: 432000,
    },
    {
        name: "Dustin Johnson",
        position: 48,
        posQualifier: "T",
        curScore: "+8",
        rounds: [ 71,72,78,75 ],
        winnings: 48060,
    },
    {
        name: "Hideki Matsuyama",
        position: 16,
        posQualifier: "T",
        curScore: "-2",
        rounds: [ 71,70,70,75 ],
        winnings: 261000,
    },
    {
        name: "Jason Day",
        position: 39,
        posQualifier: "T",
        curScore: "+5",
        rounds: [ 67,72,74,80 ],
        winnings: 75600,
    },
    {
        name: "Jon Rahm",
        position: 1,
        posQualifier: "",
        curScore: "-12",
        rounds: [ 65,69,73,69 ],
        winnings: 3240000,
    },
    {
        name: "Jordan Spieth",
        position: 4,
        posQualifier: "T",
        curScore: "-7",
        rounds: [ 69,70,76,66 ],
        winnings: 744000,
    },
    {
        name: "Justin Thomas",
        position: 54,
        posQualifier: "MC",
        curScore: "+6",
        rounds: [ 70,78,'--','--' ],
        winnings: 10000,
    },
    {
        name: "Kurt Kitayama",
        position: 54,
        posQualifier: "MC",
        curScore: "+8",
        rounds: [ 75,77,'--','--' ],
        winnings: 10000,
    },
    {
        name: "Matthew Fitzpatrick",
        position: 10,
        posQualifier: "T",
        curScore: "-4",
        rounds: [ 70,72,72,70 ],
        winnings: 432000,
    },
    {
        name: "Max Homa",
        position: 43,
        posQualifier: "T",
        curScore: "+6",
        rounds: [ 71,73,72,78 ],
        winnings: 63000,
    },
    {
        name: "Min Woo Lee",
        position: 54,
        posQualifier: "MC",
        curScore: "+6",
        rounds: [ 75,75,'--','--' ],
        winnings: 10000,
    },
    {
        name: "Patrick Cantlay",
        position: 14,
        posQualifier: "T",
        curScore: "-3",
        rounds: [ 71,71,68,75 ],
        winnings: 333000,
    },
    {
        name: "Rory McIlroy",
        position: 54,
        posQualifier: "MC",
        curScore: "+5",
        rounds: [ 72,77,'--','--' ],
        winnings: 10000,
    },
    {
        name: "Sam Burns",
        position: 29,
        posQualifier: "T",
        curScore: "+1",
        rounds: [ 68,71,78,72 ],
        winnings: 119700,
    },
    {
        name: "Scottie Scheffler",
        position: 10,
        posQualifier: "T",
        curScore: "-4",
        rounds: [ 68,75,71,70 ],
        winnings: 432000,
    },
    {
        name: "Shane Lowry",
        position: 16,
        posQualifier: "T",
        curScore: "-2",
        rounds: [ 68,72,73,73 ],
        winnings: 261000,
    },
    {
        name: "Si Woo Kim",
        position: 29,
        posQualifier: "T",
        curScore: "+1",
        rounds: [ 73,72,72,72 ],
        winnings: 119700,
    },
    {
        name: "Sungjae Im",
        position: 16,
        posQualifier: "T",
        curScore: "-2",
        rounds: [ 73,72,67,72 ],
        winnings: 261000,
    },
    {
        name: "Tom Kim",
        position: 16,
        posQualifier: "T",
        curScore: "-2",
        rounds: [ 70,72,74,70 ],
        winnings: 261000,
    },
    {
        name: "Tommy Fleetwood",
        position: 33,
        posQualifier: "",
        curScore: "+3",
        rounds: [ 72,71,74,74 ],
        winnings: 106200,
    },
    {
        name: "Tony Finau",
        position: 26,
        posQualifier: "T",
        curScore: "E",
        rounds: [ 69,74,73,72 ],
        winnings: 138600,
    },
    {
        name: "Viktor Hovland",
        position: 7,
        posQualifier: "T",
        curScore: "-6",
        rounds: [ 65,73,70,74 ],
        winnings: 580500,
    },
    {
        name: "Will Zalatoris",
        position: 80,
        posQualifier: "WD",
        curScore: "",
        rounds: [ '--','--','--','--' ],
        winnings: 10000,
    },
    {
        name: "Xander Schauffele",
        position: 10,
        posQualifier: "T",
        curScore: "-4",
        rounds: [ 68,74,71,71 ],
        winnings: 432000,
    },
]
